<p-toast position="top-center" key="tc"></p-toast>
<section id="Categoria-juegos" class="custom-section pb-10">
  <div class="Contenedor">
    <!-----tab--------------->

    <!-- Contenedor principal del componente -->
    <div class="hidden xl:flex card_color rounded-md shadow-lg w-full mt-12 h-full md:h-3/4">
      <!-- Menú de pestañas (lateral fijo) -->
      <div class="w-1/5 bg-blue text_white rounded-l-lg p-4">
        <ul id="tabs" class="space-y-2">
          <li (click)="switchMenuTo(1)" [class.active]="switchMenu===1"
            class="text_white hover:text_black tab-item p-2 rounded-md cursor-pointer flex items-center font-semibold group button_color_customize hover:button_color_customize transition duration-200">
            <div
              class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center text_color_customize group-hover:text_black">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-2xl icon icon-tabler icons-tabler-outline icon-tabler-id">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z" />
                <path d="M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                <path d="M15 8l2 0" />
                <path d="M15 12l2 0" />
                <path d="M7 16l10 0" />
              </svg>
            </div>
            <span class="text-md font-medium">Datos Personales</span>
          </li>

          <li (click)="switchMenuTo(2)" [class.active]="switchMenu===2"
            class="text_white hover:text_black tab-item p-2 rounded-md cursor-pointer flex items-center group button_color_customize hover:button_color_customize transition duration-200">
            <div
              class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center text_color_customize group-hover:text_black">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-2xl icon icon-tabler icons-tabler-outline icon-tabler-shield-lock">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
                <path d="M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                <path d="M12 12l0 2.5" />
              </svg>
            </div>
            <span class="text-md font-medium">Cambio de Contraseña</span>
          </li>

          <li (click)="switchMenuTo(3)" [class.active]="switchMenu===3"
            class="text_white hover:text_black tab-item p-2 rounded-md cursor-pointer flex items-center group button_color_customize hover:button_color_customize transition duration-200">
            <div
              class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center text_color_customize group-hover:text_black">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-2xl icon icon-tabler icons-tabler-outline icon-tabler-cash-register">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M21 15h-2.5c-.398 0 -.779 .158 -1.061 .439c-.281 .281 -.439 .663 -.439 1.061c0 .398 .158 .779 .439 1.061c.281 .281 .663 .439 1.061 .439h1c.398 0 .779 .158 1.061 .439c.281 .281 .439 .663 .439 1.061c0 .398 -.158 .779 -.439 1.061c-.281 .281 -.663 .439 -1.061 .439h-2.5" />
                <path d="M19 21v1m0 -8v1" />
                <path
                  d="M13 21h-7c-.53 0 -1.039 -.211 -1.414 -.586c-.375 -.375 -.586 -.884 -.586 -1.414v-10c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h2m12 3.12v-1.12c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2" />
                <path
                  d="M16 10v-6c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-4c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414v6m8 0h-8m8 0h1m-9 0h-1" />
                <path d="M8 14v.01" />
                <path d="M8 17v.01" />
                <path d="M12 13.99v.01" />
                <path d="M12 17v.01" />
              </svg>
            </div>
            <span class="text-md font-medium">Historial de Transacciones</span>
          </li>
        </ul>
      </div>

      <!-- Contenedor de contenido de pestañas -->
      <div id="content" class="bg_color_perfil w-4/5 p-6 overflow-y-auto">
        <!-- Contenido de la pestaña Inicio -->

        <app-personal-data *ngIf="switchMenu === 1"></app-personal-data>
        <app-change-password *ngIf="switchMenu === 2"></app-change-password>
        <app-transaction-history *ngIf="switchMenu === 3"></app-transaction-history>
      </div>
    </div>

    <!-- Acordeón para dispositivos móviles -->
    <div class="block xl:hidden space-y-4 mx-auto mt-20">
      <!-- Primer Item del Acordeón -->
      <div class="rounded-md">
        <button
          class="accordion-btn w-full px-4 py-3 text-left text-black02 font-bold card_color rounded-md focus:outline-none focus_line_customize focus_line_color_customize transition"
          (click)="toggleAccordion(1)"
          >
          <div class="flex items-center text_white">
            <div class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize text-2xl icon icon-tabler icons-tabler-outline icon-tabler-id">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z" />
                <path d="M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                <path d="M15 8l2 0" />
                <path d="M15 12l2 0" />
                <path d="M7 16l10 0" />
              </svg>
            </div>
            <span class="text-md font-medium">Datos Personales</span>
          </div>
        </button>
        <app-personal-data *ngIf="switchMenu === 1 && accordion===1"></app-personal-data>
      </div>

      <!-- Segundo Item del Acordeón -->
      <div class="rounded-md">
        <button
          class="accordion-btn w-full px-4 py-3 text-left text-black02 font-bold card_color rounded-lg focus:outline-none focus_line_customize focus_line_color_customize transition"
          (click)="toggleAccordion(2)">
          <div class="flex items-center text_white">
            <div class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize text-2xl icon icon-tabler icons-tabler-outline icon-tabler-shield-lock">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
                <path d="M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                <path d="M12 12l0 2.5" />
              </svg>
            </div>
            <span class="text-md font-medium">Cambio de Contraseña</span>
          </div>
        </button>
        
        <app-change-password *ngIf="switchMenu === 2 && accordion === 2"></app-change-password>
      </div>

      <!-- Tercer Item del Acordeón -->
      <div class="rounded-md">
        <button
          class="accordion-btn w-full px-4 py-3 text-left text-black02 font-semibold card_color rounded-lg focus:outline-none focus_line_customize focus_line_color_customize transition"
          (click)="toggleAccordion(3)">
          <div class="flex items-center text_white">
            <div class="icon-container w-8 h-8 p-1 mr-1 rounded-md text-center grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize text-2xl icon icon-tabler icons-tabler-outline icon-tabler-cash-register">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M21 15h-2.5c-.398 0 -.779 .158 -1.061 .439c-.281 .281 -.439 .663 -.439 1.061c0 .398 .158 .779 .439 1.061c.281 .281 .663 .439 1.061 .439h1c.398 0 .779 .158 1.061 .439c.281 .281 .439 .663 .439 1.061c0 .398 -.158 .779 -.439 1.061c-.281 .281 -.663 .439 -1.061 .439h-2.5" />
                <path d="M19 21v1m0 -8v1" />
                <path
                  d="M13 21h-7c-.53 0 -1.039 -.211 -1.414 -.586c-.375 -.375 -.586 -.884 -.586 -1.414v-10c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h2m12 3.12v-1.12c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2" />
                <path
                  d="M16 10v-6c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-4c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414v6m8 0h-8m8 0h1m-9 0h-1" />
                <path d="M8 14v.01" />
                <path d="M8 17v.01" />
                <path d="M12 13.99v.01" />
                <path d="M12 17v.01" />
              </svg>
            </div>
            <span class="text-md font-medium">Historial de Transacciones</span>
          </div>
        </button>
         <app-transaction-history *ngIf="switchMenu === 3 && accordion === 3"></app-transaction-history>
      </div>
    </div>

    <!------fin--------------->
  </div>
</section>
<!-- tabla last bets -->
<app-last-bets></app-last-bets>

<div class="container-profile">
  <app-footer-new></app-footer-new>
</div>
